/**
 * The unsent-filings source of the Verottajailmoitettavat project list
 * (get-verottajailmoitettava-project-ids-from-unsent-filings in 3-API) lists a
 * reportable project while it has a filing without sentAt in this month or in
 * one of the two months before it. The API reckons those months in UTC and
 * matches the filings' YYYY / MM strings. These helpers mirror that, so the
 * list can follow a filing sent or deleted here without waiting for the API.
 */

/** `YYYY-MM` keys of the months the source looks at, this month first. */
export const getUnsentFilingsSourceMonthKeys = (now = new Date()) => {
  const year = now.getUTCFullYear();
  const month = now.getUTCMonth();

  return [0, 1, 2].map((monthsBack) => {
    const monthStart = new Date(Date.UTC(year, month - monthsBack, 1));
    const monthNumber = String(monthStart.getUTCMonth() + 1).padStart(2, '0');

    return `${monthStart.getUTCFullYear()}-${monthNumber}`;
  });
};

const getFilingMonthKey = (filing) =>
  `${filing.year}-${String(filing.month).padStart(2, '0')}`;

/** Whether this filing on its own keeps its project in the source. */
export const isUnsentFilingInSourceMonths = (filing, monthKeys) =>
  Boolean(filing) &&
  !filing.sentAt &&
  !filing.deletedAt &&
  monthKeys.includes(getFilingMonthKey(filing));

/**
 * Whether a filing of `projectId` other than `exceptFilingId` keeps the
 * project in the source.
 */
export const hasOtherUnsentFilingInSourceMonths = (
  filings = [],
  { projectId, exceptFilingId, now = new Date() } = {}
) => {
  const monthKeys = getUnsentFilingsSourceMonthKeys(now);

  return filings.some(
    (filing) =>
      filing?.project === projectId &&
      filing.id !== exceptFilingId &&
      isUnsentFilingInSourceMonths(filing, monthKeys)
  );
};
